import { render, staticRenderFns } from "./mem_links_edit.vue?vue&type=template&id=682c44ce&scoped=true&"
import script from "./mem_links_edit.vue?vue&type=script&lang=js&"
export * from "./mem_links_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c44ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682c44ce')) {
      api.createRecord('682c44ce', component.options)
    } else {
      api.reload('682c44ce', component.options)
    }
    module.hot.accept("./mem_links_edit.vue?vue&type=template&id=682c44ce&scoped=true&", function () {
      api.rerender('682c44ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/editor/mem_links_edit.vue"
export default component.exports